enum OptionalRoutesEnum {
  BENEFICIARY_SERVICES = '/servicos-de-beneficiario',
  RESPONSIBILITY_LETTER = '/carta-de-responsabilidade',
}

export { OptionalRoutesEnum };
